var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_140200",
    "data-name": "Group 140200",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_165",
    "data-name": "Ellipse 165",
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    fill: "#de1515"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(8.13 6.677)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34184",
    "data-name": "Path 34184",
    d: "M10.323,15.549a.484.484,0,0,0,.3-.106c.184-.165,5.023-4.065,5.023-8.12A5.323,5.323,0,0,0,5,7.323c0,4.055,4.839,7.955,5.023,8.12a.484.484,0,0,0,.3.106ZM5.968,7.323a4.355,4.355,0,0,1,8.71,0c0,3.049-3.324,6.2-4.355,7.108C9.292,13.521,5.968,10.371,5.968,7.323Z",
    transform: "translate(-5 -2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34185",
    "data-name": "Path 34185",
    d: "M15.839,10.419a2.419,2.419,0,1,0-2.419,2.419,2.419,2.419,0,0,0,2.419-2.419Zm-3.871,0a1.452,1.452,0,1,1,1.452,1.452,1.452,1.452,0,0,1-1.452-1.452Z",
    transform: "translate(-8.097 -5.097)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoc);
export default __webpack_public_path__ + "static/media/loc.9939af7579a0daa1f94acc9e1e69b087.svg";
export { ForwardRef as ReactComponent };